import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-generic-delete-modal',
  templateUrl: './generic-delete-modal.component.html',
  styleUrls: ['./generic-delete-modal.component.scss']
})
export class GenericDeleteModalComponent {

  title: string = "";
  body: string = "";
  cancelButton: string | null = null;
  confirmButton: string | null = null;

  result: boolean = false;

  constructor(private bsModalRef: BsModalRef) { }

  onCancel() {
    this.bsModalRef.hide();
  }

  onConfirm() {
    this.result = true;
    this.bsModalRef.hide()
  }


}
